<template>
  <div>
    <b-modal id="modal-opportunity-apply" hide-header hide-footer centered>
      <div class="px-4 py-5 text-center position-relative">
        <div
          class="position-absolute tw-top-2 tw-right-2"
          role="button"
          @click="hideModal()"
        >
          <i class="icon-cerrar-simple fs-40 tw-text-red-400"></i>
        </div>
        <p
          class="text-uppercase tw-text-red-400 font-weight-bold fs-30 fs-md-50 tw-font-tolyerBold mt-3"
        >
          Aplicaste A UNA NUEVA VACANTE
        </p>
        <p class="tw-text-lg tw-text-gray-600">
          ¿Estas seguro de enviar tu hoja de vida? recuerda que tu Line Manager
          debe aprobar tu solicitud.
        </p>
        <div
          class="mt-5 d-flex flex-column flex-md-row justify-content-between"
        >
          <router-link
            to="/ambassadors/people/cv/view"
            class="mb-3 mr-0 mr-md-1 mb-md-0  tw-text-xs  fs-md-14 hover:tw-text-gray-600 tw-border tw-border-solid tw-border-gray-600 py-2 px-4 tw-rounded-md tw-bg-white tw-text-gray-600 hover:tw-bg-gray-200 w-100 w-md-50 text-center"
          >
            <svg
              width="24"
              height="30"
              viewBox="0 0 24 30"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
              class="mr-3"
            >
              <path
                d="M20.2017 0H2.80611C1.26124 0 0.00390625 1.27747 0.00390625 2.84708V24.2984L6.11758 30H20.2017C21.7466 30 23.0039 28.7225 23.0039 27.1529V2.84708C23.0039 1.27747 21.7466 0 20.2017 0ZM5.8731 28.2034L2.03286 24.6219H5.82274C5.85117 24.6219 5.87391 24.645 5.87391 24.6739V28.2034H5.8731ZM21.8668 27.1529C21.8668 28.0854 21.1195 28.8447 20.2017 28.8447H7.01023V24.6739C7.01023 24.0079 6.4774 23.4666 5.82193 23.4666H1.14103V2.84708C1.14103 1.91456 1.88829 1.15534 2.80611 1.15534H20.2017C21.1195 1.15534 21.8668 1.91456 21.8668 2.84708V27.1529Z"
                fill="#222222"
              />
              <path
                d="M17.2784 19.8242H4.81466C4.50032 19.8242 4.24609 20.0825 4.24609 20.4019C4.24609 20.7213 4.50032 20.9796 4.81466 20.9796H17.2784C17.5927 20.9796 17.8469 20.7213 17.8469 20.4019C17.8469 20.0825 17.5919 19.8242 17.2784 19.8242Z"
                fill="#222222"
              />
              <path
                d="M17.2777 22.1914H10.6272C10.3128 22.1914 10.0586 22.4497 10.0586 22.7691C10.0586 23.0884 10.3128 23.3467 10.6272 23.3467H17.2777C17.592 23.3467 17.8463 23.0884 17.8463 22.7691C17.8463 22.4497 17.5912 22.1914 17.2777 22.1914Z"
                fill="#222222"
              />
              <path
                d="M17.2777 24.5625H10.6272C10.3128 24.5625 10.0586 24.8208 10.0586 25.1402C10.0586 25.4595 10.3128 25.7178 10.6272 25.7178H17.2777C17.592 25.7178 17.8463 25.4595 17.8463 25.1402C17.8463 24.8208 17.5912 24.5625 17.2777 24.5625Z"
                fill="#222222"
              />
              <path
                d="M11.6132 9.48355C13.2157 9.48355 14.5194 8.15904 14.5194 6.53084C14.5194 4.90264 13.2157 3.57812 11.6132 3.57812C10.0107 3.57812 8.70703 4.90264 8.70703 6.53084C8.70703 8.15904 10.0107 9.48355 11.6132 9.48355ZM11.6132 4.73346C12.5887 4.73346 13.3822 5.53972 13.3822 6.53084C13.3822 7.52195 12.5887 8.32821 11.6132 8.32821C10.6377 8.32821 9.84416 7.52195 9.84416 6.53084C9.84335 5.53972 10.6377 4.73346 11.6132 4.73346Z"
                fill="#222222"
              />
              <path
                d="M6.44275 16.6994H16.5705C16.8848 16.6994 17.139 16.4411 17.139 16.1217V15.4722C17.139 12.3165 14.6122 9.75 11.507 9.75C8.40186 9.75 5.875 12.3173 5.875 15.4722V16.1217C5.87419 16.4411 6.12923 16.6994 6.44275 16.6994ZM7.01132 15.4722C7.01132 12.9536 9.02809 10.9053 11.5062 10.9053C13.9843 10.9053 16.0011 12.9544 16.0011 15.4722V15.544H7.01132V15.4722Z"
                fill="#222222"
              />
            </svg>
            <span class="tw-text-gray-600 font-weight-bold">Ver hoja de vida</span>
          </router-link>
          <div
            class="tw-bg-red-400 tw-rounded-md tw-py-3 tw-px-6 tw-text-white tw-outline-none hover:tw-bg-red-600 w-100 w-md-50 ml-0 ml-md-1"
            role="button"
            @click="applyVacant()"
          >
            <p class="mb-0 text-center">Enviar</p>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  name: "ModalOpportunityApply",
  methods: {
    applyVacant() {
      this.$emit("applyVacant");
    },
    hideModal() {
      this.$bvModal.hide("modal-opportunity-apply");
    },
  },
};
</script>
